function tail(arr) {
    return arr.slice(1);
}

export { tail };
